import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { Product } from 'src/app/api/contracts/product';

@Component({
  selector: 'app-product-search-list-item',
  templateUrl: './product-search-list-item.component.html',
  styleUrls: ['./product-search-list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductSearchListItemComponent implements OnInit {
  @Input() product!: Product;
  @Input() cartQuantity: number = 0;
  @Output() productAdded = new EventEmitter<Product>();
  @Output() bodyClicked = new EventEmitter<Product>();
  @Output() productAmountIncreased = new EventEmitter<number>();
  @Output() productAmountDecreased = new EventEmitter<number>();

  constructor() {}

  ngOnInit() {
    return;
  }
}
